import BulkUpdateTdsProperties from "../../../views/BulkUpdateTdsProperties";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const bulkUpdateTdsPropertiesRoutes = [
  {
    menuName: MenuNames.BULK_UPDATE_TDS_PROPERTIES,
    path: "/bulk-update-tds-properties",
    component: BulkUpdateTdsProperties,
    exact: true,
  },
];

export default bulkUpdateTdsPropertiesRoutes;
